import { render, staticRenderFns } from "./DonatChart.vue?vue&type=template&id=62055d1c&"
import script from "./DonatChart.vue?vue&type=script&lang=js&"
export * from "./DonatChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports